import { Component, inject } from '@angular/core';

import { AuthFacade } from '@mitsubishi/core';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-text-wrapper',
  templateUrl: './text-wrapper.component.html',
  styleUrls: ['./text-wrapper.component.scss'],
  standalone: false,
})
export class TextWrapperComponent extends FieldWrapper {
  canDebug = inject(AuthFacade).canDebug;
}
